// Shim esbuild (alias 'react-dom' → questo file): vedi shims/react.js.
// /vendor/react-dom-18.3.1.min.js è nel manifest prima dei bundle (B2.2).
export default window.ReactDOM;
